export { default } from './InputWithMagnifier';
